
<ActivationDetails
  :activation="activation"
  :context="context"
  :style="patchedDetailsStyle"
  class="sdv-embed-activation-details sdv-embed-component"
  v-on="listeners"
>
  <template #header>
    <div class="sdv-embed-activation-details__header">
      <SdvBtn
        class="sdv-embed-activation-details__close-btn"
        :svg="mdiClose"
        round
        @click="$emit('close')"
      />
    </div>
  </template>
</ActivationDetails>
